import { contentLibrary } from './content-library';
import { facebook } from './facebook';
import { kpis } from './kpis';
import { webEvents } from './webevents';

export const v1 = {
  contentLibrary,
  facebook,
  kpis,
  webEvents,
};
